import type { PageModule } from 'types/cms/PageModule';

/* INFO: We don't want to show a section divider after these blocks */
const BLOCKS_WITH_BACKGROUNDS = [
  'timeline_banner',
  'timeline_signupBanner',
  'benefits',
  'benefitsV2',
  'benefitsRef',
  'timeline_comparisonTable',
  'timeline_podcast',
  'productComparison',
  'timeline_mediaBlock',
  'timeline_productIngredients',
  'timeline_companyTimeline',
  'timeline_onwards5050',
];

export const isDividerVisible = (index: number, blocks: PageModule[]) =>
  index > 0 &&
  blocks[index - 1] &&
  !BLOCKS_WITH_BACKGROUNDS.includes(blocks[index - 1]._type);

/* INFO: This is slightly experimental. Currently to catch edge cases around
 * whether we show the divider on a block or not. Might be useful for other
 * things in the future. See components/pages/Ingredients.tsx for usage where
 * we force the divider on the first block as the header has no background. */
export interface BlockRules {
  isDividerVisible?: (index: number, blocks: PageModule[]) => boolean;
}

export const DEFAULT_BLOCK_RULES = {
  isDividerVisible,
};
